import axios from 'axios';

const axiosInstance = axios.create({
    // Request gzip/brotli compression — reduces time-series payload size by ~70-80%
    headers: {
        'Accept-Encoding': 'gzip, deflate, br',
    },
    // Fail fast on slow connections rather than hanging indefinitely
    timeout: 60000,
});

// Add credentials to all requests for session-based auth
axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.request.use(
    (config) => {

        config.withCredentials = true;

         // Try to get token from either storage method
        let token = null;

        const userStr = localStorage.getItem('user');
        if (userStr) {
            try {
                const userData = JSON.parse(userStr);
                token = userData.access;
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }

         // Fallback to direct token storage
        if (!token) {
            token = localStorage.getItem('access_token');
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }

);

// Add response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Check if error is 401 or 403 (authentication/authorization errors)
        if (error.response?.status === 401 || error.response?.status === 403) {
            // Clear all auth data
            localStorage.removeItem('user');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            delete axios.defaults.headers.common['Authorization'];

            // Try to call AuthContext clearAuth if available
            if ((window as any).__authContext?.clearAuth) {
                (window as any).__authContext.clearAuth();
            }

            // Redirect to React login page (avoid infinite loops)
            if (window.location.pathname !== '/login') {
                // Use React Router navigation instead of window.location if possible
                if ((window as any).__navigate) {
                    (window as any).__navigate('/login');
                } else {
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);

    }
);


export default axiosInstance;
